import { dgnbApi, getLocalAuthHeader } from "api-client";
import { DGNBFormData } from "store/DGNBStore";

export default async function handleDgnbPassportCreate(
  dgnbFormData: DGNBFormData
) {
  const localAuthHeader = getLocalAuthHeader();
  const { buildingId, outputType, dgnbPassport } = dgnbFormData;
  try {
    const response = await dgnbApi.reportApiV1RoutersDgnbPassportCreate(
      buildingId as string,
      outputType,
      dgnbPassport,
      localAuthHeader
    );
    return response.data;
  } catch (e) {
    console.error("Failed to create DGNB Passport", e, buildingId);
  }
}
